import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzSelectModule } from 'ng-zorro-antd';


import { PaginationComponent } from './pagination.component';


export const COMPONENTS = [PaginationComponent];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NzSelectModule
  ],
  exports: [...COMPONENTS],
  declarations: [...COMPONENTS],
  entryComponents: [...COMPONENTS]

})
export class PaginationModule { }
